import { render, staticRenderFns } from "./GallRomDetails.vue?vue&type=template&id=0e9ffdd6&scoped=true&"
import script from "./GallRomDetails.vue?vue&type=script&lang=js&"
export * from "./GallRomDetails.vue?vue&type=script&lang=js&"
import style0 from "./GallRomDetails.vue?vue&type=style&index=0&id=0e9ffdd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9ffdd6",
  null
  
)

export default component.exports